import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/home';
  };

  handleReload = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4" data-testid="error-boundary-fallback">
          <div className="bg-card rounded-2xl shadow-lg border border-border p-8 max-w-lg w-full text-center">
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-5">
              <AlertTriangle size={32} className="text-amber-600" />
            </div>
            <h2 className="text-xl font-bold text-foreground mb-2">
              Etwas ist schiefgelaufen
            </h2>
            <p className="text-muted-foreground mb-6">
              Ein unerwarteter Fehler ist aufgetreten. Bitte laden Sie die Seite neu oder kehren Sie zum Dashboard zurück.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <pre className="text-left text-xs text-red-600 bg-red-50 p-3 rounded-lg mb-4 overflow-auto max-h-40 border border-red-200">
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack?.slice(0, 500)}
              </pre>
            )}
            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleReload}
                data-testid="error-boundary-reload-btn"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity font-medium"
              >
                <RefreshCw size={16} />
                Seite neu laden
              </button>
              <button
                onClick={this.handleReset}
                data-testid="error-boundary-home-btn"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-border rounded-lg hover:bg-accent transition-colors font-medium text-foreground"
              >
                <Home size={16} />
                Zum Dashboard
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
